/* eslint-disable camelcase */

import common_en from './en/common.json';
import common_ar from './ar/common.json';


import errors_en from './en/errors.json';
import errors_ar from './ar/errors.json';

export default {
  en: {
    common: common_en,
    errors: errors_en,
  },
 
  ar: {
    common: common_ar,
    errors: errors_ar,
  },
};
